var hitbox = 'ncq90n2';
var root = 'ncq90n1';

export { hitbox, root };
//# sourceMappingURL=slider-primitive.css.js.map
